import extractServerErrorMessage from '../extractServerErrorMessage/extractServerErrorMessage';

const parsePayload = (payload: unknown): string | null => {
  if (!payload) {
    return null;
  }

  if (typeof payload === 'string') {
    try {
      const parsed = JSON.parse(payload) as Record<string, unknown>;
      return extractServerErrorMessage(parsed) ?? payload;
    } catch {
      return payload;
    }
  }

  if (Array.isArray(payload)) {
    const [firstValue] = payload;
    if (typeof firstValue === 'string') {
      return firstValue;
    }
    if (typeof firstValue === 'object' && firstValue) {
      return extractServerErrorMessage(firstValue as Record<string, unknown>);
    }
    return null;
  }

  if (typeof payload === 'object') {
    return extractServerErrorMessage(payload as Record<string, unknown>);
  }

  return null;
};

/**
 * Extract a human-readable error message from an axios/superagent-style error.
 * Walks response.data -> body -> text -> statusText, parsing JSON-string bodies
 * and delegating dict-shaped DRF errors (e.g. {"pre_fx_currency": ["..."]}) to
 * extractServerErrorMessage. Returns null when nothing usable is found.
 */
const extractResponseErrorMessage = (error: any): string | null =>
  parsePayload(error?.response?.data) ??
  parsePayload(error?.response?.body) ??
  parsePayload(error?.response?.text) ??
  (typeof error?.response?.statusText === 'string' ? error.response.statusText : null);

export default extractResponseErrorMessage;
